module.exports = __webpack_public_path__ + "static/img/p_04.373c44f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/p_04.png
// module id = 758
// module chunks = 1